import { Typography } from "@mui/material";

const Text = ({ children, ...props }) => {
  return (
    <Typography
      {...props}
      variant="subtitle1"
      lineHeight="1.25"
      fontWeight="normal"
      pt={2}
      letterSpacing={0}
    >
      {children}
    </Typography>
  );
};

export default Text;
